import TabToggleList from 'components/commons/tab-toogle-list'
import UploadImage from 'components/commons/upload-image'
import { Button, InlineError, Input } from 'avo-ui'
import icAddSquare from 'assets/images/ic-add-square.svg'

export const BannerDailyDeals = ({ items, setItems, onChangeItem, onAddNewItem, errorForm }) => {
    const getError = (key, index) => {
        const findError = errorForm?.daily_deal?.banners_detail?.find((i) => i?.index === index && i?.key === key)
        return findError?.message
    }

    return (
        <div className={'flex flex-col space-y-6'}>
            {items?.map((item, index) => (
                <TabToggleList
                    key={`banner-daily-deals-${index}`}
                    index={index}
                    title={`Banner-Daily-Deals-Item-${index + 1}`}
                    content={
                        <div className={'flex space-x-16'}>
                            <div
                                className={`flex-1 flex-col ${(item?.image_url?.base64 || item?.image_url?.length) && 'space-y-3'}`}
                            >
                                <div className={'font-semibold text-blue-90 required'}>Mini Banner (254px x 156px)</div>
                                <UploadImage
                                    className={'w-fit'}
                                    classNameImage={'!w-fit !h-fit max-h-80 border border-neutral-30 rounded-md'}
                                    id={`mini-banner-${index}`}
                                    value={item?.image_url?.base64 || item?.image_url}
                                    onChange={(value) =>
                                        onChangeItem({
                                            name: 'image_url',
                                            value,
                                            index,
                                        })
                                    }
                                />
                                <InlineError className='mt-2' message={getError('image_url', index)} />
                            </div>
                            <div className={'flex-1 flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90 required'}>Link Direction</div>
                                <Input
                                    className={'flex-1'}
                                    name={'url'}
                                    placeholder={'Masukkan link direction'}
                                    value={item?.url}
                                    onChange={(item) => onChangeItem({ ...item, index })}
                                />
                                <InlineError className='mt-2' message={getError('url', index)} />
                            </div>
                        </div>
                    }
                    items={items}
                    setItems={setItems}
                    isDisableDelete={items?.length === 1}
                    isSorting
                />
            ))}
            <InlineError className='mt-2' message={errorForm?.daily_deal?.banners} />
            <Button
                className={'w-fit'}
                type={'outline'}
                icon={icAddSquare}
                title={'Add New Item'}
                onClick={onAddNewItem}
            />
        </div>
    )
}
